import { render, staticRenderFns } from "./competitionarrange.vue?vue&type=template&id=77902872&scoped=true"
import script from "./competitionarrange.vue?vue&type=script&lang=js"
export * from "./competitionarrange.vue?vue&type=script&lang=js"
import style0 from "./competitionarrange.vue?vue&type=style&index=0&id=77902872&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77902872",
  null
  
)

export default component.exports